import { firestore } from '../firebase'
const manuelInvoiceSetREF = firestore.collection('manAccountingSet')


export const setManuelInvoice = (invoice) => {
    const newId = manuelInvoiceSetREF.doc()
    console.log(newId)
    //return manuelInvoiceSetREF.set(invoice)
}